// Capacitor-aware helpers. We avoid a hard dependency on @capacitor/core so the
// web build works before Capacitor is installed; we feature-detect at runtime.
export function isNativePlatform(): boolean {
  const cap = (globalThis as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
  return Boolean(cap?.isNativePlatform?.())
}

// Absolute origin of the booking API. In dev this is empty → relative "/api/..."
// which Vite proxies to the Symfony backend (no CORS). For Capacitor/native and
// production builds, VITE_API_BASE points at the live origin.
export const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '')

// True on Apple devices (iOS / iPadOS) — native Capacitor app or mobile Safari. Used to show the
// "Add to Apple Wallet" option, which only makes sense on iOS.
export function isApplePlatform(): boolean {
  const cap = (globalThis as unknown as { Capacitor?: { getPlatform?: () => string; isNativePlatform?: () => boolean } }).Capacitor
  if (cap?.isNativePlatform?.()) return cap.getPlatform?.() === 'ios'
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

// Go-live flag for Google Wallet. The "Add to Google Wallet" button stays HIDDEN until the Google
// issuer is approved for publishing — before then, tapping it errors for any non-test account.
// Flip VITE_GOOGLE_WALLET_LIVE=true in the build env once Google grants publishing access.
export const GOOGLE_WALLET_LIVE = import.meta.env.VITE_GOOGLE_WALLET_LIVE === 'true'

// Fatturazione (billing) is TEMPORARILY HIDDEN across the app (booking info step, profile,
// registration) so anyone can book without invoicing. UI-only: the backend is untouched — it still
// sends reservations to the gestionale (with fattura="0") and keeps SIRAC sending. To restore the
// full billing flow, set VITE_BILLING_ENABLED=true in the build env — no code change needed.
export const BILLING_ENABLED = import.meta.env.VITE_BILLING_ENABLED === 'true'

// True on Android — native Capacitor app or mobile Chrome. Used to show the "Add to Google Wallet"
// option, which only makes sense on Android.
export function isAndroidPlatform(): boolean {
  const cap = (globalThis as unknown as { Capacitor?: { getPlatform?: () => string; isNativePlatform?: () => boolean } }).Capacitor
  if (cap?.isNativePlatform?.()) return cap.getPlatform?.() === 'android'
  if (typeof navigator === 'undefined') return false
  return /Android/.test(navigator.userAgent)
}
